(() => {
  'use strict';
  if (window.kvrBrightenerLoaded) return;
  window.kvrBrightenerLoaded = true;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root = document) {
    root.querySelectorAll('[data-kvr-main]').forEach(section => {
      if (section.dataset.kvrReady) return;
      section.dataset.kvrReady = 'true';
      const $ = selector => section.querySelector(selector);
      const slides = [...section.querySelectorAll('.gallery-main [data-slide]')];
      const thumbs = [...section.querySelectorAll('[data-image]')];
      let current = 0, touch, lastFocus;
      const dialog = $('dialog'), strip = $('.thumbnails');
      function select(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((button, i) => {
          button.classList.toggle('selected', i === current);
          button.setAttribute('aria-pressed', String(i === current));
        });
        const caption = $('[data-kvr-caption]'); if (caption) caption.textContent = slides[current].dataset.caption;
        const counter = $('[data-kvr-counter]'); if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
        const thumb = thumbs[current];
        if (thumb && (thumb.offsetLeft < strip.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth)) {
          strip.scrollTo({ left: Math.max(0, thumb.offsetLeft - 12), behavior: reduced() ? 'instant' : 'smooth' });
        }
      }
      section.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (button?.matches('[data-image]')) select(Number(button.dataset.image));
        if (button?.matches('.previous')) select(current - 1);
        if (button?.matches('.next')) select(current + 1);
        if (button?.matches('[data-gallery]')) {
          select(Number(button.dataset.gallery));
          $('.gallery').scrollIntoView({ behavior: reduced() ? 'instant' : 'smooth', block: 'start' });
        }
        if (button?.matches('[data-kvr-zoom]') && slides.length) {
          const clone = slides[current].cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          $('[data-kvr-zoom-content]').replaceChildren(clone);
          lastFocus = button;
          dialog.showModal();
        }
        if (button?.matches('[data-kvr-close]')) dialog.close();
        if (event.target.closest('[data-kvr-shipping]')) {
          const details = section.querySelector('details[id^="kvr-shipping"]');
          if (details) details.open = true;
        }
      });
      strip.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        select(current + (event.key === 'ArrowRight' ? 1 : -1));
        thumbs[current]?.focus({ preventScroll: true });
      });
      $('.gallery-main').addEventListener('touchstart', event => {
        touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      $('.gallery-main').addEventListener('touchend', event => {
        if (!touch) return;
        const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) select(current + (dx < 0 ? 1 : -1));
        touch = null;
      }, { passive: true });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { lastFocus?.focus({ preventScroll: true }); });
      section.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) select(index);
      });
      const sticky = $('[data-kvr-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].boundingClientRect.bottom > 0; }, { threshold: 0 });
        observer.observe($('.product-shell'));
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
      select(0);
    });
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-kvr-top]')) return;
    const product = document.querySelector('[data-kvr-main]');
    if (product) { event.preventDefault(); product.scrollIntoView({ behavior: reduced() ? 'instant' : 'smooth' }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  if (window.kvrVideosReady) return;
  window.kvrVideosReady = true;
  const pauseDialog = dialog => { if (dialog?.matches('.kvr-video-dialog')) dialog.querySelector('video').pause(); };
  document.addEventListener('close', event => pauseDialog(event.target), true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-kvr-video]');
    if (trigger) {
      const dialog = trigger.closest('[data-kvr-main]').querySelector('.kvr-video-dialog');
      const video = dialog.querySelector('video');
      video.src = trigger.dataset.kvrVideo;
      dialog.showModal();
      video.play().catch(() => { /* Native controls remain available. */ });
    }
    if (event.target.closest('.kvr-video-close')) event.target.closest('dialog').close();
    if (event.target.matches('.kvr-video-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
